import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ExternalMember } from '../../shared/models/member/external-member.model';
import { ExternalMemberRepository } from '../../shared/services/member/external-member-repository.service';
import { ToastrService } from '../../shared/services/utils/toastr.service';
import { AppAuthService } from '../services/app-auth.service';

@Component({
  selector: 'def-external-registration-form',
  templateUrl: './external-registration-form.component.html',
  styleUrls: ['./external-registration-form.component.scss'],
})
export class ExternalRegistrationFormComponent {
  currentSubscription: Subscription;
  member: ExternalMember = new ExternalMember({
    isB2b: true,
  });

  private readonly successTitle = 'EXTERNALREGISTRATIONFORM.SUCCESS.TITLE';
  private readonly successMessage = 'EXTERNALREGISTRATIONFORM.SUCCESS.MESSAGE';

  constructor(
    private externalMemberService: ExternalMemberRepository,
    private router: Router,
    private toastr: ToastrService,
  ) {
  }

  submitForm() {
    this.currentSubscription = this.externalMemberService.create(this.member)
      .subscribe(
        () => this.onSuccess(),
      );
  }

  private onSuccess() {
    this.router.navigateByUrl(AppAuthService.defaultPage);
    this.toastr.success(this.successMessage, this.successTitle);
  }
}
